import React, { useEffect } from 'react';
import "./index.scss";

import AppTool from '@utils/app-tool';

const LoadingDialog = (props) => {


  const handleClose = () => {
  
    AppTool.closeDialog('.cLoadingDialog')
  };

  useEffect(() => {
  }, []);


  return (
    <div className="cLoadingDialog cLoadingDialogAttr" >
      <div className="cMask" onClick={() => { handleClose() }}></div>
      <div className="cDialog" style={{backgroundImage : `url(${window.assetUrl('/images/loading-bg.jpg')})`}}>
        <img className='cLoading' src="/images/loading.gif" alt='' />
      </div>
    </div>
  )
}

export default LoadingDialog;